import React, {useState, useEffect} from 'react';
import { getAuth, setPersistence, signInWithEmailAndPassword, browserSessionPersistence } from "firebase/auth";
import { useNavigate }  from 'react-router-dom';
import  bg  from '../../src/assets/bg.svg'
import useAuth from '../context/useAuth';


function Login(getFirestoreDocs) {

  useEffect(() => { 
  const inputs = document.querySelectorAll(".input");

  function addcl(){
    let parent = this.parentNode.parentNode;
    parent.classList.add("focus");
  }

  function remcl(){
    let parent = this.parentNode.parentNode;
    if(this.value === ""){
      parent.classList.remove("focus");
    }
}
inputs.forEach(input => {
	input.addEventListener("focus", addcl);
	input.addEventListener("blur", remcl);
});
  });

  const handleSubmit=(event)=>{
    event.preventDefault();
  }

  const auth = getAuth();
 
  const { setLogin } = useAuth();
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const navigate = useNavigate();


  const signIn= () => {  

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {         
        setLogin({email});
        navigate("/dashboard")
        setPersistence(auth, browserSessionPersistence)

      })
      .catch((error) => {
        alert("E-mail ou senha incorretos")
        console.log(error.code)
      });
  }

  return (

          <div className='login'>
            <div className='waves'>
              <div className="loginContainer">
                <div className="img">
                  <img src={bg} alt={'alt'}/>
                </div>
                <div className="login-content">
                  <form onSubmit={handleSubmit}>
                  <div className="formulario" >
                    <h2 className="title">Login Reveles</h2>
                    <div className="input-div one">
                      <div className="i">
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                      <div className="div">
                        <h5>E-mail</h5>
                        <input type="text"
                        class="input"
                        placeholder='E-mail'
                          required
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                          />
                      </div>
                    </div>
                    <div className="input-div pass">
                      <div className="i">
                        <i className="fas fa-lock"></i>
                      </div>
                      <div className="div">
                        <h5>Senha</h5>
                        <input
                        type="password" 
                        required
                        placeholder='senha'
                        onChange={(e) => setPassword(e.target.value)}
                        class="input"
                        value={password}
                        />
                      </div>
                    </div>
                  <button className="btn" onClick={signIn}>Login</button>
                  </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Versão 1.0 */}
          </div>

  );
}

export default Login;
